//Requires leafletPip
;(function(global, $)
{

	var popupManager = null;

	var PopupManager = function(options){
		if (null === popupManager){
			popupManager = new PopupManager.init(options);
		}
		return popupManager;
	}

	PopupManager.prototype = {

		options: {
			addSublayers: false,
			hideExtraTabs: true,
			maxVisibleTabs: 1,
			id: 'mng',
			class: 'popup',
			html: '',
			disable: false
		},

		numTabs: 0,

		createPopupContents: function(matches, tabs) {
			var self = this;
			var options = self.options;
			var lis = [];
			var contents = [];
			var numVisibleTabs = matches.length;
			self.numTabs = matches.length;
			var hasHiddenTabs = numVisibleTabs > options.maxVisibleTabs && options.hideExtraTabs;
			numVisibleTabs = hasHiddenTabs ? options.maxVisibleTabs : numVisibleTabs;
			var popupWidth = 200;
			var tabWidth = popupWidth/numVisibleTabs;
			if (undefined === tabs)
			{
				tabs = true;
			}

			matches.sort(function(a, b) {
				if(a.isWMS && b.isWMS)
					return 0;
				else if(!a.isWMS)
					return -1;
				else if(!b.isWMS)
					return 1;
				else 
					return 0;
			});

			for(var i=0, len=matches.length; i<len; ++i)
			{
				var match = matches[i];
				var title = '';
				var layerTitle = '';
				var content = '';
				if(match.isWMS)
				{
					title = match.name;
					if(match.isQueryable)
						content = match.content;
				}
				else
				{
					title = match.properties.title;
					if ((title=='' || title==undefined) &&  match.properties.feature!==undefined &&  match.properties.feature.properties!==undefined &&  match.properties.feature.properties.title!==undefined) {
						title = match.properties.feature.properties.title;
					} 
					layerTitle = match.properties.capaNom;
					title = title ? title : layerTitle;
					content = match.properties.popupData;
				}

				if('' != content)
				{
					if(!tabs)
					{
						contents.push({title: title, htmlContent: content, layerTitle: layerTitle});
					}
					else
					{
						if (1 < self.numTabs){
							lis.push(self.createTabTitle(title || layerTitle, i, tabWidth, (i<options.maxVisibleTabs)));
						}
						contents.push(self.createTabContent(content, i));
					}
				}
			}

			if(!tabs){
				return contents;
			}else{
				var html = '';
				if (self.numTabs>1){
					html = '<div id="popup-' + options.id + '" class="' + options.class + '">' + 
						'<ul class="nav nav-tabs pagination nomargin">';
		
					if(hasHiddenTabs)
					{
						html += '<li id="popup-' + options.id + '-prev" data-taboffset=0 class="margin1" style="display:none;">' +
							'<a href="#" aria-label="Previous" class="prevTab">' + 
							'<span aria-hidden="true" class="tabArrow">&laquo;</span></a></li>';
					}
		
					html += lis.join('');
		
					if(hasHiddenTabs)
					{
						html += '<li id="popup-' + options.id + '-next" class="margin1">' +
							'<a href="#" aria-label="Next" class="nextTab">' +
							'<span aria-hidden="true" class="tabArrow">&raquo;</span></a></li>';
					}
		
					html += '</ul><div class="tab-content">' + contents.join('') + '</div></div>';
				}
				else {
					html = '<div id="popup-' + options.id + '" class="' + options.class + '">' ;
					html += '<div class="tab-content">' + contents.join('') + '</div></div>';
				}
				
				self.options.html = html;
				return html;
			
			}
		},

		createTabTitle: function(name, index, tabWidth, isVisible) {
			var self = this;
			var options = self.options;
			var isActive = (0 == index);

			return '<li id="popup-' + options.id + '-tab-' + index + '" class="' + 
				(isActive ? ' active margin1' : 'margin1') + ' " style="' + 
				(isVisible ? '' : 'display:none') + '"><a href="#popup-' + 
				options.id + '-content-' + index + '" data-toggle="tab" class="popupTitleTab" style="' + 
				'width: ' + tabWidth + 'px; text-overflow: ellipsis;" >' +
				name + '</a></li>'
		},

		createTabContent: function(data, index) {
			var self = this;
			var options = self.options;
			var isActive = (0 == index);

			return '<div class="tab-pane' + (isActive ? ' active' : '') + '" id="popup-' + 
				options.id + '-content-' + index + '">' + data + '</div>';
		},

		createMergedDataPopup: function(feat, event, visibleLayers, tabs) {
			console.log("createMergedDataPopup");
			var self = this;
			var deferred = $.Deferred();
			var layersVisible = visibleLayers;
			$("body").trigger("closeProfile");
			if(self.disable == true){
				deferred.resolve({features:[]});
			}else{
				if (undefined === tabs)
				{
					tabs = true;
				}
				if (visibleLayers.length===undefined && visibleLayers._layers !==undefined){
					var layers = [];
					var i=0;
					jQuery.each(visibleLayers._layers, function(index, obj){
						layers[i] = obj;
						i++;
					});
					layersVisible = layers;
				}
				//var visibleLayers = control.getVisibleLayers(self.options.addSublayers);
				var latlng = event.latlng;
				if(!latlng){
					latlng = event.target._latlng;
					if(!latlng){
						latlng = feat._latlng;
					}
				}
				
				if(event.originalEvent) {
					event.originalEvent.stopImmediatePropagation();
					event.originalEvent.preventDefault();
					latlng = map.mouseEventToLatLng(event.originalEvent);
				}

				$('#popup-' + self.options.id + ' .nav-tabs').empty();
				$('#popup-' + self.options.id + ' .tab-content').empty();

				var matches = [];
				var panMap = true;
				for(var i=0, len=layersVisible.length; i<len; ++i)
				{
					var currentLayer = layersVisible[i];

					if(currentLayer.layer.options && currentLayer.layer.options.tipus && 
						(t_wms == currentLayer.layer.options.tipus) ||
						(t_vis_wms == currentLayer.layer.options.tipus))
					{
						
						self.addWMSMatch(currentLayer.layer, i, matches);

						if(t_wms == currentLayer.layer.options.tipus)
						{

							self.doWMSRequest(currentLayer.layer, event, i);

						}
						else {

							self.doUTFGridWMS(currentLayer.layer, event, i)

						}
					}else {
						var match = leafletPip.pointInLayer(latlng, currentLayer.layer, false);
						for(var j=0, lenJ=match.length; j<lenJ; ++j){
							matches.push(match[j]);
						}
					}
				}
				
				if(event.elements)
				{
					for (var i = event.elements.length - 1; i >= 0; i--) {
						var element = event.elements[i];
						var isMatched = false;
						for (var g = matches.length - 1; g >= 0; g--) {
							if (matches[g].properties.businessId === element.properties.businessId){
								isMatched = true;
							}
						}
						if(!isMatched){
							matches.push(element);
						}
					}
				}
				//console.log(matches);
				if(!tabs)
				{
					var isUnderPanel =  self._isClickUnderPanel(event);
					isUnderPanel.pan = panMap;
					var tabsArray = self.createPopupContents(matches,false);
					var dataPupup = {isUnder: isUnderPanel, features: tabsArray};
					deferred.resolve(dataPupup);
				}
				else
				{
					self.options.html = self.createPopupContents(matches, true);
					if(0 != matches.length)
					{
						self.updateVisibleTabTitles();
					}

					if(InstamapsUtils.Validator.isModeMapa($(location).attr('href'))){
						
						self.clicked = {} ;
						self.modified = {};
						self.businessidGeom ='';
						self.idLeaflet='';

					}
					
					deferred.resolve(self.options.html);
				}
			}
			return deferred.promise();
		},

		_addPopupEvents: function(){
			var self = this;
			$('#popup-' + self.options.id + '-prev').on('click', function(e) {
				self.previousTab(e);
			});
			$('#popup-' + self.options.id + '-next').on('click', function(e) {
				self.nextTab(e);
			});

			if(InstamapsUtils.Validator.isModeMapa($(location).attr('href'))){

				$('#closeSidebar').on('click',function(e){
					
					e.stopImmediatePropagation();
					e.preventDefault();
					e.stopPropagation();
					$("body").trigger("closeProfile");
					var modified = self.modified;
					if (modified !== undefined) {
						var keys = Object.keys(modified);
						if(0 != keys.length)
						{
							var dataUpdate ={
								uid:Cookies.get('uid'),
								businessId: self.businessidGeom,//PENDENT!!!
								newValue: JSON.stringify(self.modified)
							};
							updateGeometriaPropertiesByBusinessId(dataUpdate).then(function(results){
								if (results.status == "OK"){
									self.modified={};
									self.clicked = {} ;
									var layerServidor = results.servidor;
									reloadSingleLayer(controlCapes._layers[self.idLeaflet], layerServidor);
								}else{
									console.debug('error updateGeometriaProperties');
								}
							},function(results){
								console.debug('error updateGeometriaProperties');
							});	
						}
					}			
					
				});

				$("[contenteditable='true']").on('focus', function(e) {	
					var clau=e.currentTarget.attributes[2].nodeValue;
					var valor=e.currentTarget.innerText;
					try {
						$("#edit_"+clau).hide();
						$("#edit_"+clau+"_2").show();
						if(valor === ""){
							if(e.currentTarget.innerHTML.indexOf('img') !== -1) {
								e.currentTarget.innerHTML = $(e.currentTarget.innerHTML).attr('href');
								valor = e.currentTarget.innerHTML;
							}
						}
						self.clicked[clau]=valor;	
					}
					catch(e){

					}		
				});
				
				$("[contenteditable='true']").on('blur', function(e) {
					//console.log("blur");
					var clau=e.currentTarget.attributes[2].nodeValue;
					var valor=e.currentTarget.innerText;
					try{
						var original = self.clicked[clau];
						if(original != valor) {
							var keyModified = clau.replaceAll("___"," ").replaceAll("__",".");
							self.modified[keyModified]=valor;
							if (self.businessidGeom=="") self.businessidGeom = $('#businessidGeom').val();
							if (self.idLeaflet=="") self.idLeaflet=$('#idLeaflet').val();
						}
					}catch(e){
						
					}
				});

				$("[contenteditable='true']").on('keyup', function(e) {
					//console.log("keyup");
					if (e.keyCode=="13"){
						e.preventDefault();
						var clau=e.currentTarget.attributes[2].nodeValue;
						var valor=e.currentTarget.innerText;
						var id = e.currentTarget.id;
						var original = self.clicked[clau];
						if(original != valor) {
							var keyModified = clau.replaceAll("___"," ").replaceAll("__",".");
							self.modified[keyModified]=valor;
							if (self.businessidGeom=="") self.businessidGeom = $('#businessidGeom').val();
							if (self.idLeaflet=="") self.idLeaflet=$('#idLeaflet').val();
							self.modificarDadesGeometria("edit_"+id+"_2");
						}
					}
				});
				
				$(".glyphicon-pencil").on('click', function(e) {
					//console.log("click pencil");			
					var id = e.currentTarget.id;
					$("#"+id).hide();
					$("#"+id+"_2").show();
					$("#"+id.replace("edit_","")).focus();
					/*
					$_this = $("#"+id.replace("edit_",""));
					if($_this.first().html().indexOf('img') !== -1) {
						$_this.first().html($($_this.first().html()).attr('href'));
					}
					$_this.focus();
					*/
				});

				$(".glyphicon-ok").on('click', function(e) {
					//console.log("click ok");			
					var id = e.currentTarget.id;
					var modified = self.modified;
					if (modified === undefined) {
						self.modified= {};
						var id2 = id.replace("_2","").replace("edit_","");
						var valor = $('#'+id2)[0].innerHTML;
						var keyModified = id2.replaceAll("___"," ").replaceAll("__",".");
						self.modified[keyModified]=valor;
						if (self.businessidGeom=="") self.businessidGeom = $('#businessidGeom').val();
						if (self.idLeaflet=="") self.idLeaflet=$('#idLeaflet').val();						
					}
					self.modificarDadesGeometria(id);
					
				});

			}

		},

		setPopupData: function(data, index)
		{

			var self = this;
			$('#wms-content-' + self.options.id + '-' + index).html(data);
			$('#wms-content-' + self.options.id + '-' + index).removeClass('noOverflow');

		},

		doWMSRequest: function(layer, event, index)
		{

			var self = this;
			var tileWMS = L.tileLayer.betterWms(layer._url, layer.wmsParams);
			tileWMS.options.queryable = layer.options.queryable;
			tileWMS._map = map;
		
			tileWMS.getPopupContent(event, index).then(function(data) {
					if (data.content.indexOf("html")==1){
						var html = "<iframe style='height:800px;' srcdoc='"+data.content+"'></iframe>";
						self.setPopupData(html, index);
					}
					else {
						self.setPopupData(data.content, index);
					}
					
					var esVisor = (-1 != $(location).attr('href').indexOf('instavisor')) || (-1 != $(location).attr('href').indexOf('visor'));

					/*if (data.content == "<br/>El WMS no retorna informació en aquest punt."){
						if (!esVisor){
							setTimeout(function(){
								InstamapsUtils.Mapa.closePopup(jQuery, map);
							},4000);
						}
						else {
							setTimeout(function(){
								getInstamapsMapViewer().closePinModal();
							},4000);
							
						}

						
					}*/
			});
		
			

		},

		doUTFGridWMS: function(layer, event, index)
		{

			var self = this;
			var utfGrid = new L.utfGrid(layer._url, 
				createOptionsUtfGrid(layer.wmsParams, layer.options));
			utfGrid._map = map;
			utfGrid._update().then(function() {
				var data = utfGrid.createPopup(utfGrid._objectForEvent(event).data);
				self.setPopupData(data, index);
			});

		},

		addWMSMatch: function(layer, index, matches) {

			var self = this;
			var loader = '<div id="preloader6" style="margin-left:calc(50% - 24px);">' +
				'<span></span><span></span><span></span><span></span>' +
				'</div>';
			var spanInfo ='<span style="margin-left: 100px;">Recuperant informació</span>';

			matches.push({isWMS: true, 
				name: layer.options.nom, 
				content: '<div id="wms-content-' + self.options.id + '-' + index + '" class="noOverflow">' + loader + spanInfo +'</div>',
				isQueryable: layer.options.queryable
			});

		},

		previousTab: function(e)
		{

			var self = this;
			var $btn = $('#popup-' + self.options.id + '-prev');
			var offset = Number.parseInt($btn.data('taboffset')) - 1;
			$btn.data('taboffset', offset);

			var displayPrev = (0 == offset || -1 == offset) ? 'none' : 'block';
			$('#popup-' + self.options.id + '-prev').css('display', displayPrev);

			self.updateVisibleTabTitles();

		},

		nextTab: function(e)
		{

			var self = this;
			var $btnPrev = $('#popup-' + self.options.id + '-prev');
			var $btn = $('#popup-' + self.options.id + '-next');
			var offset = Number.parseInt($btnPrev.data('taboffset')) + 1;
			$btnPrev.data('taboffset', offset);

			var displayNext = ((offset + self.numVisibleTabs) >= self.numTabs) ? 'none' : 'block';
			$('#popup-' + self.options.id + '-next').css('display', displayNext);
			
			self.updateVisibleTabTitles();

		},

		updateVisibleTabTitles: function()
		{

			var self = this;

			var $tabs = $('[id^=popup-' + self.options.id + '-tab-]');
			var $btnPrev = $('#popup-' + self.options.id + '-prev');
			var offset = Number.parseInt($btnPrev.data('taboffset'));
			var maxVisible = offset + self.options.maxVisibleTabs;
			var currentTabId = 0;
			
			for(var i=0, len=self.numTabs; i<len; ++i)
			{

				var current = $($tabs[i]);
				var display = (i < offset || i >= maxVisible) ? 'none' : 'block';
				current.css('display', display);
				if ('block' == display) {
					$('a[href^="#popup-' + self.options.id + '-content-'+i).click();
					currentTabId=i;
				}
			}
			
			var displayNext = (currentTabId==self.numTabs-1) ? 'none' : 'block';
			$('#popup-' + self.options.id + '-next').css('display', displayNext);
			
			var displayPrev = (currentTabId==0) ? 'none' : 'block';
			$('#popup-' + self.options.id + '-prev').css('display', displayPrev);
		},
		
		_getNameField: function(feature){
			var name_field = {};
			if (feature.properties.data!=undefined){
				if (feature.properties.data.nom && !InstamapsUtils.Validator.isBusinessId(feature.properties.data.nom)){
					name_field["nom"]=feature.properties.data.nom;
					return name_field;
				}else if (feature.properties.data.Nom && !InstamapsUtils.Validator.isBusinessId(feature.properties.data.Nom)){
					name_field["Nom"]=feature.properties.data.Nom;
					return name_field;
				}else if (feature.properties.data.NOM && !InstamapsUtils.Validator.isBusinessId(feature.properties.data.NOM)){
					name_field["NOM"]=feature.properties.data.NOM;
					return name_field;
				}else if(feature.properties.data.name && !InstamapsUtils.Validator.isBusinessId(feature.properties.data.name)){
					name_field["name"]=feature.properties.data.name;
					return name_field;
				}else if(feature.properties.data.Name && !InstamapsUtils.Validator.isBusinessId(feature.properties.data.Name)){
					name_field["Name"]=feature.properties.data.Name;
					return name_field;
				}else if(feature.properties.data.NAME && !InstamapsUtils.Validator.isBusinessId(feature.properties.data.NAME)){
					name_field["NAME"]=feature.properties.data.NAME;
					return name_field;
				}else if(feature.properties.data.nombre && !InstamapsUtils.Validator.isBusinessId(feature.properties.data.nombre)){
					name_field["nombre"]=feature.properties.data.nombre;
					return name_field;
				}else if(feature.properties.data.Nombre && !InstamapsUtils.Validator.isBusinessId(feature.properties.data.Nombre)){
					name_field["Nombre"]=feature.properties.data.Nombre;
					return name_field;
				}else if(feature.properties.data.NOMBRE && !InstamapsUtils.Validator.isBusinessId(feature.properties.data.NOMBRE)){
					name_field["NOMBRE"]=feature.properties.data.NOMBRE;
					return name_field;
				}
			}
			else{
				if (feature.properties.nom && !InstamapsUtils.Validator.isBusinessId(feature.properties.nom)){
					name_field["nom"]=feature.properties.nom;
					return name_field;
				}else if (feature.properties.Nom && !InstamapsUtils.Validator.isBusinessId(feature.properties.Nom)){
					name_field["Nom"]=feature.properties.Nom;
					return name_field;
				}else if (feature.properties.NOM && !InstamapsUtils.Validator.isBusinessId(feature.properties.NOM)){
					name_field["NOM"]=feature.properties.NOM;
					return name_field;
				}else if(feature.properties.name && !InstamapsUtils.Validator.isBusinessId(feature.properties.name)){
					name_field["name"]=feature.properties.name;
					return name_field;
				}else if(feature.properties.Name && !InstamapsUtils.Validator.isBusinessId(feature.properties.Name)){
					name_field["Name"]=feature.properties.Name;
					return name_field;
				}else if(feature.properties.NAME && !InstamapsUtils.Validator.isBusinessId(feature.properties.NAME)){
					name_field["NAME"]=feature.properties.NAME;
					return name_field;
				}else if(feature.properties.nombre && !InstamapsUtils.Validator.isBusinessId(feature.properties.nombre)){
					name_field["nombre"]=feature.properties.nombre;
					return name_field;
				}else if(feature.properties.Nombre && !InstamapsUtils.Validator.isBusinessId(feature.properties.Nombre)){
					name_field["Nombre"]=feature.properties.Nombre;
					return name_field;
				}else if(feature.properties.NOMBRE && !InstamapsUtils.Validator.isBusinessId(feature.properties.NOMBRE)){
					name_field["NOMBRE"]=feature.properties.NOMBRE;
					return name_field;
				}
			}
		
		},
		
		_isADrawMarker: function(feature){
			if (key=='text' || key=='TEXT') isADrawMarker=true;
			else isADrawMarker=false;
			return isADrawMarker;
		},
		
		_getPropertiesHtml: function(feature,data,estil_do,noEsDinamic,noEsDadesObertes,isTematic,campNameField){
			var html="";
			var propFormat="";
			var propName="";
			var propAlies="";
			var capa=data.capa;
			if (capa!=undefined && capa.options!=undefined && capa.options.propFormat!=undefined) 	propFormat = capa.options.propFormat;
			if (capa!=undefined && capa.options!=undefined && capa.options.propName!=undefined) 	propName = capa.options.propName;
			if (capa!=undefined && capa.options!=undefined && capa.options.propAlies!=undefined) 	propAlies = capa.options.propAlies;
			var esVisor=data.esVisor;
			var origen=data.origen;
			var properties;
			if (feature.properties.data!=undefined && ("string" !== typeof feature.properties.data)) properties=feature.properties.data;
			else if (feature.properties!=undefined) properties=feature.properties;
			if ("" === propName) propName = Object.keys(properties).join();
			
			var propPrivacitat = "";
			var propImatge = "";
			if (capa!=undefined && capa.options!=undefined && capa.options.propPrivacitat!=undefined) 	propPrivacitat = capa.options.propPrivacitat;
			if (propPrivacitat==="" && origen!==""){
				var layerMare = map._layers[origen];
				if (layerMare!==undefined && layerMare.options!=undefined && layerMare.options.propPrivacitat!=undefined) propPrivacitat = layerMare.options.propPrivacitat;
			}
			if (capa!=undefined && capa.options!=undefined && capa.options.propImatge!=undefined) propImatge = capa.options.propImatge;
			if (propImatge==="" && origen!==""){
				var layerMare = map._layers[origen];
				if (layerMare!==undefined && layerMare.options!=undefined && layerMare.options.propImatge!=undefined) propImatge = layerMare.options.propImatge;
			}
			var dataNames = (typeof propName === "string" ? propName.split(',') : propName);
			for(var x in dataNames){
				var key  = dataNames[x];
				var lowerCaseKey = key.toLowerCase();
				var nameF=lowerCaseKey;
				nameF= nameF.replaceAll(" ","_");
				nameF=nameF.replaceAll("(","_");
				nameF=nameF.replaceAll(")","_");
				nameF=nameF.replaceAll("%","_");
				nameF=nameF.replaceAll("'","_");
				var isFeatProp = "latitud"== lowerCaseKey || "longitud"== lowerCaseKey || "etrs89_x"== lowerCaseKey || "etrs89_y"== lowerCaseKey || "cota" == lowerCaseKey;
				var isLineProp = "longitud (km)"==lowerCaseKey;
				var isPolygonProp ="area (ha)"==lowerCaseKey;
				var esEditable = !esVisor && noEsDinamic && !isLineProp && !isPolygonProp && !isFeatProp && noEsDadesObertes && !isTematic;
				if ((propPrivacitat==="" )|| (propPrivacitat!="" && (propPrivacitat[key]==true || propPrivacitat[lowerCaseKey]==true || propPrivacitat[nameF]==true))) {
					var value = properties[key];
					if (undefined=== value || "" === value || "-" === value) {
						value=properties[lowerCaseKey];
					}
					var isVisible = (esVisor && InstamapsUtils.Validator.isValidValue(value)) || !esVisor;
					var isImage = (propImatge!="" && (propImatge[key]==="imatge" || propImatge[lowerCaseKey]==="imatge" || propImatge[nameF]==="imatge" ));
					if((key) && isVisible && !InstamapsUtils.Validator.isWKT(value)){
						if (key != 'businessId' && key != 'slotd50' && 
								key != campNameField &&
								lowerCaseKey!= 'popupdata' && lowerCaseKey!='capanom'	){
							html+='<div class="popup_data_row">';
							var txt=value;
							
							if (!$.isNumeric(txt)) {
								txt = InstamapsUtils.Getters.parseUrlTextPopUp(value, key, isImage);
								if (typeof txt === "string") {
									if(txt!=undefined && txt.indexOf("iframe")==-1 && txt.indexOf("img")==-1){
										if (propFormat!=undefined && (propFormat[key]!=undefined || propFormat[lowerCaseKey]!=undefined)){
											var propF = propFormat[lowerCaseKey];
											if (undefined == propF) propF=propFormat[key];
											txt = dataFormatter.formatValue(txt, propF);
										}
										var keyText = key;
									    if (propAlies!==undefined && propAlies[key.toLowerCase()]!==undefined) keyText = propAlies[key.toLowerCase()];
										html+='<div class="popup_data_key">'+keyText+'</div>';
										html+='<div class="popup_data_value" ';
										if (esEditable) html+='contenteditable="true"';
										var keyModified = key.replaceAll(" ","___").replaceAll(".","__");
										html+='  clau="'+keyModified+'" id="'+keyModified+'">'+
										(InstamapsUtils.Validator.isBlank(txt)?window.lang.translate("Sense valor"):txt);									
										html+='</div>';
										if (esEditable) html+=this._addIconEditField(keyModified);
									}else{
										if (txt!=undefined) {
											html+='<div class="popup_data_img_iframe" ';
											if (esEditable) html+='contenteditable="true"';
											var keyModified = key.replaceAll(" ","___").replaceAll(".","__");
											html+= ' clau="'+keyModified+'" id="'+keyModified+'">'+txt;
											html+='</div>';
											if (esEditable) html+=this._addIconEditField(keyModified);
										}
									}
								}
								else {
									if (txt!=undefined) {
										html+='<div class="popup_data_img_iframe" ';
										if (esEditable) html+='contenteditable="true"';
										var keyModified = key.replaceAll(" ","___").replaceAll(".","__");
										html+= ' clau="'+keyModified+'" id="'+keyModified+'">'+txt;
										html+='</div>';
										if (esEditable) html+=this._addIconEditField(keyModified);
									}
								}
							}
							else {
								if (propFormat!=undefined && (propFormat[key]!=undefined || propFormat[key.toLowerCase()]!=undefined)){
									var propF = propFormat[lowerCaseKey];
									if (undefined == propF) propF=propFormat[key];
									txt = dataFormatter.formatValue(txt, propF);
								}
								if (txt!=undefined && key!=undefined) {
									var keyText = key;
									if (propAlies!==undefined && propAlies[key.toLowerCase()]!==undefined) keyText = propAlies[key.toLowerCase()];
									html+='<div class="popup_data_key">'+keyText+'</div>';
									html+='<div class="popup_data_value" ';
									if (esEditable) html+='contenteditable="true"';
									var keyModified = key.replaceAll(" ","___").replaceAll(".","__");;
									html+=' clau="'+keyModified+'" id="'+keyModified+'">'+txt;
									html+='</div>';
									if (esEditable) html+=this._addIconEditField(keyModified);
								}
							}
							html+= '</div>';
							
						}
					}
				}
			}
		
			return html;
		},
			
		_addIconEditField: function(key,estitol){
			var html="";
			var styleTitle="";
			if (estitol) styleTitle="margin-top:-35px;margin-right:20px;";
			html+='<i class="glyphicon glyphicon-pencil gris-semifosc2" style="float:right;display:inline;'+styleTitle+'" id="edit_'+key+'"></i>';
			html+='<i class="glyphicon glyphicon-ok verd14" style="float:right;display:none;'+styleTitle+'" id="edit_'+key+'_2"></i>';
			
			return html;
		},

		_addGeometriesProps: function(feature, type){
			var html = "";
			if ((type==t_marker || type === "Point") && undefined!=feature.geometry && (feature.geometry.type==t_point || feature.geometry.type=="Point")) {
				html+=this._addHeightToPoint(feature);
			}
			else if(type == t_polyline && feature.properties.mida &&  undefined!=feature.geometry && feature.geometry.type==t_linestring){
				html+=this._addLengthToLine(feature);
			}else if(type == t_polygon && feature.properties.mida &&  undefined!=feature.geometry && feature.geometry.type==t_polygon){
				html+=this._addAreaToPolygon(feature);
			}
			return html;
		},

		_addLatLongToMarker:function(feature){
			    var html="";
				var auxLat = "";
				if (feature._latlng!=undefined) auxLat = feature._latlng.lat;
				else if (feature.geometry!=undefined){
					if(feature.geometry.coordinates!=undefined){
						auxLat = feature.geometry.coordinates[0];
					}
				}
				auxLat = auxLat.toFixed(5);
				var auxLon = "";
				if (feature._latlng!=undefined) auxLon = feature._latlng.lng;
				else if (feature.geometry!=undefined){
					if(feature.geometry.coordinates!=undefined){
						auxLon = feature.geometry.coordinates[1];
					}
				}				
				auxLon = auxLon.toFixed(5);			
				html+='<div id="mida_pres"><b>'+window.lang.translate('Longitud')+':</b> '+auxLon+',<b>'+window.lang.translate('Latitud')+':</b> '+auxLat+'</div>';
				return html;
		},

		_addETRS89ToMarker:function(feature){
		    var html="";
			var auxLat = "";
			if (feature._latlng!=undefined) auxLat = feature._latlng.lat;
			else if (feature.geometry!=undefined){
				if(feature.geometry.coordinates!=undefined){
					auxLat = feature.geometry.coordinates[0];
				}
			}
			auxLat = auxLat.toFixed(5);
			var auxLon = "";
			if (feature._latlng!=undefined) auxLon = feature._latlng.lng;
			else if (feature.geometry!=undefined){
				if(feature.geometry.coordinates!=undefined){
					auxLon = feature.geometry.coordinates[1];
				}
			}				
			auxLon = auxLon.toFixed(5);		
			proj4.defs('EPSG:25831', '+proj=utm +zone=31 +ellps=GRS80 +datum=WGS84 +units=m +no_defs');
			var coords = proj4('EPSG:25831', 'WGS84', [auxLat, auxLon]);
			var auxX=coords[0];
			var auxY=coords[1];
			html+='<div id="mida_pres"><b>'+window.lang.translate('ETRS89_X')+':</b> '+auxX+',<b>'+window.lang.translate('ETRS89_Y')+':</b> '+auxY+'</div>';
			return html;
		},

		_addLengthToLine: function(feature){
			var html="";
			html+='<div id="mida_pres"><b>'+window.lang.translate('Longitud')+':</b> '+feature.properties.mida+'</div>';
			return html;
		},

		_addAreaToPolygon: function(feature){
			var html="";
			if (feature.properties.mida!=undefined && feature.properties.mida.indexOf("NaN")==-1)	html+='<div id="mida_pres"><b>'+window.lang.translate('Àrea')+':</b> '+feature.properties.mida+'</div>';
			else html+='<div id="mida_pres"><b>'+window.lang.translate('Àrea')+':</b> '+L.GeometryUtil.readableArea(L.GeometryUtil.geodesicArea(feature.getLatLngs()[0]),true)+'</div>';
			return html;
		},

		_addHeightToPoint: function(feature){
			var html="";
			if (feature.properties.cota!=undefined && feature.properties.cota.indexOf("NaN")==-1)	html+='<div id="mida_pres"><b>'+window.lang.translate('Alçada (m.)')+':</b> '+feature.properties.cota+'</div>';
			else if (feature.properties.data!=undefined && feature.properties.data.cota!=undefined && feature.properties.data.cota.indexOf("NaN")==-1)	html+='<div id="mida_pres"><b>'+window.lang.translate('Alçada (m.)')+':</b> '+feature.properties.data.cota+'</div>';
			return html;
		},

		_addActionButtons: function(feature,data){
			var editable=data.editable;
			var type=data.type;
			var origen=data.origen;
			var html="";
			
			if(editable){
				html += this.createEditableFooterButtons(feature, type);
			}else{
				var esVisor = (-1 != $(location).attr('href').indexOf('instavisor')) || (-1 != $(location).attr('href').indexOf('visor'));
				if (esVisor) {
					if (data.taulaDades==undefined || (data.taulaDades!==undefined && data.taulaDades==true)){
						var paramsKey = getInstamapsMapViewer().isInIframe ? "iframe" : "visor";
						var optionsToCheck = getInstamapsMapViewer().instamapsConfig.options && getInstamapsMapViewer().instamapsConfig.options.params ? getInstamapsMapViewer().instamapsConfig.options.params[paramsKey] : {scalecontrol: false, mouseposition: false};
						if (optionsToCheck.tauladedadescontrol!==undefined && optionsToCheck.tauladedadescontrol===0) { 
							html+="";
						}
						else {
							html += this._createNonEditableFooterButtons(feature, type);
						}
						
					}
				}	

			}
			return html;
		},

		createDinamicFooterButtons: function(feature, type, businessId) {
			var html='';
			html+= '<div id="popup_footer">';
			html+='<ul class="bs-popup" style="text-align:center">';
			html+='<li class="edicio-popup"></li>';
			html+='<li class="edicio-popup"></li>';
			html+=PopupManager()._createDataTableListItem(feature,type,businessId);
			html+='<li class="edicio-popup"></li>';
			html+='<li class="edicio-popup"></li>';
			html+='</ul>';
			html+='</div>';
			return html;
		},

		createEditableFooterButtons: function(feature, type) {

			var footerContent = this._createEditableFooterContent(feature, type);
			return this._createFooter(footerContent);

		},

		_createNonEditableFooterButtons: function(feature, type) {

			var footerContent = this._createNonEditableFooterContent(feature, type);
			return this._createFooter(footerContent);

		},

		_createEditableFooterContent: function(feature, type) {

			return this._createEditableIconList(feature, type);

		},

		_createFooter: function(content) {

			return '<div id="footer_edit"  class="modal-footer">' + 
				content + 
				'</div>';

		},

		_createEditableIconList: function(feature, type) {

			var html = '<ul class="bs-popup">';
			html += this._createStyleListItem(feature, type);
			if(this._isPolyline(type) || this._isPolygon(type)) {

				html += this._createEditListItem(feature, type);

				if(this._isPolyline(type)) {

					html += this._createProfileListItem(feature, type);
				}

			}
			else {
				html += this._createMoveListItem(feature, type);
			}
			html += this._createRemoveListItem(feature, type);
			html += this._createDataTableListItem(feature, type);
			html += this._createFAQListItem(feature, type);
			html += '</ul>';

			return html;

		},

		_createStyleListItem: function(feature, type) {

			var icon = this._createStyleIcon(feature, type);
			return this._createListItem(icon)

		},

		_createEditListItem: function(feature, type) {

			var icon = this._createEditIcon(feature, type);
			return this._createListItem(icon)

		},

		_createProfileListItem: function(feature, type) {

			var icon = this._createProfileIcon(feature, type);
			return this._createListItem(icon)

		},

		_createMoveListItem: function(feature, type) {

			var icon = this._createMoveIcon(feature, type);
			return this._createListItem(icon)

		},

		_createRemoveListItem: function(feature, type) {

			var icon = this._createRemoveIcon(feature, type);
			return this._createListItem(icon)

		},

		_createDataTableListItem: function(feature, type, businessIdLayer) {

			var icon = this._createDataTableIcon(feature, type, businessIdLayer);
			return this._createListItem(icon)

		},

		_createFAQListItem: function(feature, type) {

			var icon = this._createFAQIcon(feature, type);
			return this._createListItem(icon)

		},

		_createStyleIcon: function(feature, type) {

			return this._createIconLink('edit', feature._leaflet_id, type, 'geostart-palette font18', window.lang.translate('Estils'));

		},

		_createEditIcon: function(feature, type) {

			return this._createIconLink('move', feature._leaflet_id, type, 'glyphicon glyphicon-pencil', window.lang.translate('Editar'));

		},

		_createProfileIcon: function(feature, type) {
			return this._createIconLink('profile', feature._leaflet_id, type, 'fa fa-area-chart', window.lang.translate('Perfil'));

		},

		_createMoveIcon: function(feature, type) {

			return this._createIconLink('move', feature._leaflet_id, type, 'glyphicon glyphicon-move', window.lang.translate('Moure'));

		},

		_createRemoveIcon: function(feature, type) {

			return this._createIconLink('remove', feature._leaflet_id, type, 'glyphicon glyphicon-trash', window.lang.translate('Esborrar'));

		},

		_createDataTableIcon: function(feature, type, businessIdLayer) {
			return this._createIconLink('data_table', feature._leaflet_id, type + '##' + feature.properties.capaLeafletId, 'glyphicon glyphicon-list-alt', window.lang.translate('Dades'),businessIdLayer);

		},

		_createFAQIcon: function(feature, type) {

			return '<a class="faqs_link" href="https://betaportal.icgc.cat/wordpress/faq-dinstamaps/#mapestematics" target="_blank"><span class="fa fa-question-circle-o gris-semifosc font21"></span></a>';

		},

		_createIconLink: function(iconType, featureId, type, className, name, businessIdLayer) {

			var html= '<a id="feature_' + iconType + '##' + featureId + '##' + type +'"';
			if (businessIdLayer!==undefined) {
				html+=' data-businessIdLayer="'+businessIdLayer+'"';
			} 
			html+=' lang="ca" href="#">' + 
			'<span class="gris-semifosc ' + className + '" data-toggle="tooltip" data-placement="bottom" title="' +
			name +
			'"></span></a>';
			return html;

		},
		
		_createListItem: function(content) {

			return '<li class="edicio-popup">' +
				content +
				'</li>';

		},

		_isPolyline: function(type) {
		
			return type == t_polyline;

		},

		_isPolygon: function(type) {
		
			return type == t_polygon;

		},

		_createNonEditableFooterContent: function(feature, type) {

			return this._createNonEditableIconList(feature, type);

		},

		_createNonEditableIconList: function(feature, type) {
		
			var html = '<ul class="bs-popup">';
			if(this._isPolyline(type)) {

				html += this._createProfileListItem(feature, type);

			}
			html += this._createDataTableListItem(feature, type);
			html += '</ul>';

			return html;

		},
		
		getPropName: function(feature){
			var propName = "";
			var properties;
			if (feature.properties.data!=undefined) properties=feature.properties.data;
			else if (feature.properties!=undefined) properties=feature.properties;
			$.each( properties, function( key, value ) {
				propName = propName+key+",";
			});
			propName = propName.substr(0, propName.length-1);
			return propName;
		},
		
		getDataFieldValue: function(feature,estil_do){
			var properties,dataFieldValue;
			if (feature.properties.data!=undefined) properties=feature.properties.data;
			else if (feature.properties!=undefined) properties=feature.properties;
			$.each( properties, function( key, value ) {
				if(estil_do!=undefined && (key.toLowerCase()==estil_do.dataField || key==estil_do.dataField)) dataFieldValue = value;
			});
			return dataFieldValue;
		},

		_addComboCapes: function(feature,type){
			var html='';
			html+='<ul class="bs-ncapa">'
				+'<li class="li-capes-popup"><span lang="ca" class="small">'+window.lang.translate('Capa actual:')+'</span>'
				+'<select id="cmbCapesUsr-'+feature._leaflet_id+'-'+type+'-'+feature.properties.capaLeafletId+'" data-leaflet_id='+feature._leaflet_id+'>';
			html+= fillCmbCapesUsr(type,feature._leaflet_id);
			html+= '</select></li>'
				+'<li class="li-add-layer"><a id="layer_add#'+feature._leaflet_id+'#'+type+'" lang="ca" title="Crear una nova capa" href="#"><span class="glyphicon glyphicon-plus gris-semifosc2"></span></a></li>'
				+'</ul>';
			html+='<div class="popup_edit">'
				+'<div  style="display:block" id="capa_txt">'
				+'<div id="layer_accio"></div>'
				+'<input class="form-control" id="capa_edit" type="text" value="'+feature.properties.capaGrup+'" placeholder="">'
				+'</div>'
				+'<div class="modal-footer">'
				+'<ul class="bs-popup">'
				+'<li class="botons1"><a id="feature_no##'+feature._leaflet_id+'##'+type+'"  class="btn btn-default btn-xs">'+window.lang.translate('Cancel·lar')+'</a></li>'			
				+'<li class="botons2"><a id="feature_ok##'+feature._leaflet_id+'##'+type+'"  class="btn btn-success btn-xs">'+window.lang.translate('Acceptar')+'</a></li>'								
				+'</ul>'														
				+'</div>'
				+'</div>';		
			return html;
		},

		createPopupHtml: function(feature, data, dadesObertes, estil_do,dinamic){
			if (dinamic==undefined 
				&& data 
				&& data.capa 
				&& data.capa.layer
				&& data.capa.layer.options
				&& data.capa.layer.options.dinamic) {
				
				dinamic=data.capa.layer.options.dinamic;

			}
			var isCluster = false;
			if  (data.esCluster!==undefined) isCluster = data.esCluster;
			var html='';
			var esVisor=data.esVisor;
			var noEsDinamic=undefined==dinamic || (undefined!=dinamic && !dinamic);
			var noEsDadesObertes=undefined==dadesObertes || (dadesObertes!=undefined && !dadesObertes);
			var capa=data.capa;
			var propPrivacitat = "", propAlies = "";
			var campPrincipal="";
			var isTematic=false;
			if (capa!=undefined && capa.options!=undefined && capa.options.propAlies!=undefined) 	propAlies = capa.options.propAlies;	
			if (capa!=undefined && capa.options!=undefined && capa.options.propPrivacitat!=undefined) 	propPrivacitat = capa.options.propPrivacitat;
			if (capa!=undefined && capa.options!=undefined && capa.options.campPrincipal!=undefined) 	campPrincipal = capa.options.campPrincipal;
			if (capa!=undefined && capa.options!=undefined && capa.options.tipusRang!=undefined) isTematic = (capa.options.tipusRang===tem_clasic || capa.options.tipusRang===tem_size);
			var nameField = this._getNameField(feature);
			var campNameField = "";
			if (nameField!==undefined && Object.keys(nameField).length>0 && campPrincipal=="") campNameField = Object.keys(nameField); 
			html+='<input type="hidden" id="businessidGeom" value="'+feature.properties.businessId+'">';
			html+='<input type="hidden" id="idLeaflet" value="'+feature.properties.capaLeafletId+'">';
			html+='<div class="title-key">';
			var color = (estil_do) 
				? estil_do.color
				: "#000000";
			var classSuffix = "";
			if (data.type==t_marker || data.type === "Point") {
				if(feature.properties.estil)
					color = feature.properties.estil.marker;

				classSuffix = "-marcador_A";
			}
			else if(data.type == t_polyline){
				if(feature.properties.estil)
					color = feature.properties.estil.color;

				classSuffix = "-linia";
			}else if(data.type == t_polygon){
				if(feature.properties.estil)
					color = feature.properties.estil.color;
				classSuffix = "-area";
			}
			html+='<span class="instaicon' + classSuffix + '" style="font-size:17px;color:'+color+'"></span>';
			var title = "";
			if (campPrincipal!==undefined && campPrincipal!==""){
				if (campPrincipal === "layerName"){
						title  = feature.properties.capaNom;
				}
				else {
					title = feature.properties.data[campPrincipal];
				}				
			}
			else {
				campPrincipal = "layerName"; 
				title = feature.properties.capaNom;
			}
			if (nameField!==undefined && Object.keys(nameField).length>0 && campNameField!=="") {
				var clau = Object.keys(nameField);
				if (clau[0] !== campPrincipal) {
					var nameF = clau[0].toLowerCase();
					nameF= nameF.replace(" ","_");
					nameF=nameF.replace("(","_");
					nameF=nameF.replace(")","_");
					nameF=nameF.replace("%","_");
					nameF=nameF.replace("'","_");
					var isVisible = (propPrivacitat!="" && (propPrivacitat[clau[0]]==true || propPrivacitat[clau[0].toLowerCase()]==true || propPrivacitat[nameF]==true)) || propPrivacitat=="";
					if (nameField[clau[0]]!="" && nameField[clau[0]]!="-"  && isVisible){
						html+='<h4 class="my-text-center" ';
						if (!esVisor && noEsDinamic && noEsDadesObertes) html+='contenteditable="true"';
						html+= ' id="'+clau[0]+'" clau="'+clau[0]+'">'+nameField[clau[0]];
						html+='</h4>';
						if (!esVisor && noEsDinamic && noEsDadesObertes && !isTematic) {
							html+=this._addIconEditField(clau[0],false);
						}
					}
				}
				
			}
			else {
				if (!isCluster) {
				if (!esVisor) {
					html+='<h4 class="my-text-center" ';
					if (!esVisor && noEsDinamic && noEsDadesObertes) html+='contenteditable="true"';
					html+= ' id="'+campPrincipal+'" clau="'+campPrincipal+'">'+title;
					html+='</h4>';
					if (!esVisor && noEsDinamic && noEsDadesObertes && !isTematic) {
						html+=this._addIconEditField(campPrincipal,false);
					}
				}
				}
			}
			html+='</div>';			
			html+='<div class="div_popup_visor"><div class="popup_pres">';
			html+=this._getPropertiesHtml(feature,data,estil_do,noEsDinamic,noEsDadesObertes,isTematic,campNameField[0]);			
			if (!esVisor && ((undefined==dadesObertes && undefined==dinamic) || (dadesObertes!=undefined && !dadesObertes) || (dinamic!=undefined && !dinamic))) html+=this._addGeometriesProps(feature,data.type);
			html+='</div><div id="elevation##' + feature._leaflet_id + '" data-id="' + feature._leaflet_id + '" class="elevationPanel" style="display: none"></div><div id="popup_footer">';
			if(!isTematic && !esVisor && ((undefined==dadesObertes && undefined==dinamic) || (dadesObertes!=undefined && !dadesObertes) || (dinamic!=undefined && !dinamic))) html+=this._addComboCapes(feature,data.type);		
			if(!isTematic && (undefined==dadesObertes && undefined==dinamic) || (dadesObertes!=undefined && !dadesObertes) || (dinamic!=undefined && !dinamic)) html+=this._addActionButtons(feature,data);
			html+='</div>'; //#popup_footer
			html+='</div>';//.div_popup_visor
			return html;
		},
		
		addEventsPopup: function(){
			var self = this;
			//self.addEventSemaforic();
			self.addEventsAccionsPopup();
		},

		addEventsAccionsPopup: function() {
			var self=this;
			$(document).on('click', ".bs-popup li a", function(e) {
				e.stopImmediatePropagation();
				var accio , businessIdLayer;
				if(undefined != $(this).attr('id') && $(this).attr('id').indexOf('##')!=-1){	
					accio=$(this).attr('id').split("##");				
				}
				if(undefined != $(this).attr('data-businessIdLayer') ){	
					businessIdLayer=$(this).attr('data-businessIdLayer');				
				}
				if (accio!=undefined && accio[1]!=undefined) objEdicio.featureID=accio[1];
				
				if(undefined != accio[0] && accio[0].indexOf("feature_edit")!=-1){

					//Update modal estils, amb estil de la feature seleccionada
					var obj = map._layers[accio[1]];
					//console.debug(obj);
					var icon;
					if(obj.options.icon /*|| obj.options.icon.options.markerColor.indexOf("punt_r")!=-1*/){
						icon = obj.options.icon.options;	
					}else if(obj._options!==undefined && !jQuery.isEmptyObject(obj._options)){
						icon = obj._options;
					}else{
						icon = obj.options;
					}
					updateDialogStyleSelected(icon);
					
					if(accio[2].indexOf("marker")!=-1){
						obrirMenuModal('#dialog_estils_punts','toggle',from_creaPopup);
					}else if(accio[2].indexOf("polygon")!=-1){
						obrirMenuModal('#dialog_estils_arees','toggle',from_creaPopup);
					}else{
						obrirMenuModal('#dialog_estils_linies','toggle',from_creaPopup);
					}
				}else if(undefined != accio[0] && accio[0].indexOf("feature_data_table")!=-1){
					$('#sidebar').attr("class","unactive");
					$('.leaflet-control-scale.leaflet-control').removeClass("popup-active");
					InstamapsUtils.Mapa.closePopup(jQuery, map);
					$.publish('closePinPopup');
					$('#modal_data_table').modal('show');
					var featureId=objEdicio.featureID;
					if (featureId===undefined) featureId=accio[2];
					if (map._layers[featureId]==undefined) {
						try{
							if (accio[6]!=undefined) featureId=accio[6];
							if (featureId===undefined || (featureId!==undefined && featureId==="undefined")){
								fillModalDataTableDinamic(businessIdLayer);
							}
							else {
								if (map._layers[featureId]!=undefined) {
									var props=map._layers[featureId].properties;
									if (props==undefined) props=map._layers[featureId].options;
									if (accio[3]==undefined)  fillModalDataTable(controlCapes._layers[accio[2]],props.businessId);
									else fillModalDataTable(controlCapes._layers[accio[3]],props.businessId);
								}
								else {
									var visibleLayers = InstamapsLayers().getVisibleLayers(PopupManager().getOptions().addSublayers);
									for(var i=0, len=visibleLayers.length; i<len; ++i)
									{
										var currentLayer = visibleLayers[i];
										if (currentLayer.layer._leaflet_id === parseInt(accio[3])){
											fillModalDataTable(currentLayer,currentLayer.layer.businessId);
										}
									}									
								}//console.log(accio);
							}
						}
						catch(err){
							console.debug(err);
						}
					}
					else {						
						if (controlCapes!==undefined) {
							if (featureId===undefined){
								fillModalDataTableDinamic(businessIdLayer);
							}
							else {
								fillModalDataTable(controlCapes._layers[accio[3]],map._layers[featureId].properties.businessId);
							}
							
						}
						else {
							var visibleLayers = InstamapsLayers().getVisibleLayers(PopupManager().getOptions().addSublayers);
							for(var i=0, len=visibleLayers.length; i<len; ++i)
							{
								var currentLayer = visibleLayers[i];
								if (currentLayer.layer._leaflet_id === parseInt(accio[3])){
									fillModalDataTable(currentLayer,currentLayer.layer.businessId);
								}
							}
							
						}
						
					}

				}else if(undefined != accio[0] && accio[0].indexOf("feature_remove")!=-1){
					InstamapsUtils.Mapa.closePopup(jQuery, map);
					$('#sidebar').attr("class","unactive");
					$('.leaflet-control-scale.leaflet-control').removeClass("popup-active");
					var data = {
			            businessId: map._layers[objEdicio.featureID].properties.businessId,
			            uid: Cookies.get('uid')
			        };
				
					var features = {
						type:"Feature",
						id: 3124,
						businessId: map._layers[objEdicio.featureID].properties.businessId,
						properties: map._layers[objEdicio.featureID].properties.data,
						estil: map._layers[objEdicio.featureID].properties.estil,
						geometry: map._layers[objEdicio.featureID].properties.feature.geometry
					};				
					
					features = JSON.stringify(features);
					features = features.replace("\"opacity\":0.9","\"opacity\":1");
					features = features.replace("\"fillOpacity\":0.9","\"fillOpacity\":1");
					var data = {
						businessId: map._layers[objEdicio.featureID].properties.capaBusinessId,//bID de la visualitzacio-capa
						uid: Cookies.get('uid'),
						features: features
					};
					var businessIdCapaOrigen=map._layers[objEdicio.featureID].properties.capaBusinessId;
					removeGeometriaFromVisualitzacio(data).then(function(results){
						if(results.status == 'OK'){						
							var capaLeafletId = map._layers[objEdicio.featureID].properties.capaLeafletId;
							var capaBusinessId = map._layers[objEdicio.featureID].properties.capaBusinessId;
							if(map._layers[capaLeafletId]!= undefined) map._layers[capaLeafletId].removeLayer(map._layers[objEdicio.featureID]);					
							if(map._layers[objEdicio.featureID]!= null) map.removeLayer(map._layers[objEdicio.featureID]);	
							if(map._layers[capaLeafletId]!= undefined) {
								updateFeatureCount(map._layers[capaLeafletId].options.businessId, null);
							}
							else {						
								updateFeatureCount(capaBusinessId, null);		
							}		
							 var layer = controlCapes._layers[capaLeafletId];
							//recarrego les sublayers de la capa modificada	
							actualitzacioTematic(layer,businessIdCapaOrigen,null,null,null,"baixa");

						}else{
							console.debug("ERROR deleteFeature");
						}
					},function(results){
						console.debug("ERROR deleteFeature");
					});					
				}else if(undefined != accio[0] && accio[0].indexOf("feature_text")!=-1){
					modeEditText();
				}else if(undefined != accio[0] && accio[0].indexOf("feature_move")!=-1){
					var featureSelect =  map._layers[objEdicio.featureID];
					if (self.esGeometriaEditable(featureSelect)){
						objEdicio.esticEnEdicio=true;
						var capaLeafletId = featureSelect.properties.capaLeafletId;	
						objEdicio.capaEdicioLeafletId = capaLeafletId;//Ho guarda per despres poder actualitzar vis filles
						//Actualitzem capa activa
						if (capaUsrActiva){
							capaUsrActiva.removeEventListener('layeradd');
						}
						capaUsrActiva = map._layers[capaLeafletId];
						
						var capaEdicio = new L.FeatureGroup();
						capaEdicio.addLayer(featureSelect);
						capaUsrActiva.removeLayer(featureSelect);
						map.addLayer(capaEdicio);
						
						var opcionsSel={
							color: '#FF1EE5',
							"weight": 7,
							opacity: 0.6,
							dashArray: '1, 1',
							fill: true,
							fillColor: '#fe57a1',
							fillOpacity: 0.1
						};

						crt_Editing = new L.EditToolbar.Edit(map, {
							featureGroup: capaEdicio,
							selectedPathOptions: opcionsSel
						});
						
						crt_Editing.enable();		
						InstamapsUtils.Mapa.closePopup(jQuery, map);
						$('#sidebar').attr("class","unactive");
						$('.leaflet-control-scale.leaflet-control').removeClass("popup-active");
							
					}else{

						self.showErrorModal("Aquesta geometria no és editable perquè està definida com a multigeometria");

					}
				}else if(undefined != accio[0] && accio[0].indexOf("feature_no")!=-1){
					$('.popup_pres').show();
					$('.bs-ncapa').show();
					$('.popup_edit').hide();
					
				}else if(undefined != accio[0] && accio[0].indexOf("feature_ok")!=-1){
					if(objEdicio.edicioPopup=='textFeature'){
						var txtTitol=$('#titol_edit').val();
						var txtDesc=$('#des_edit').val();
						if (txtDesc.indexOf("'")>-1) txtDesc = txtDesc.replaceAll("'",'"');
						updateFeatureNameDescr(map._layers[objEdicio.featureID],txtTitol,txtDesc);

					}else if(objEdicio.edicioPopup=='textCapa'){
						if($('#capa_edit').val()!=""){
							$('#cmbCapesUsr option:selected').text($('#capa_edit').val());	
							$('.popup_pres').show();
							$('.popup_edit').hide();
						}else{
							alert(window.lang.translate('Has de posar un nom de capa'));	
						}
					}else if(objEdicio.edicioPopup=='nouCapa'){
						if($('#capa_edit').val()!=""){
							generaNovaCapaUsuari(map._layers[objEdicio.featureID],$('#capa_edit').val());
						}else{
							alert(window.lang.translate('Has de posar un nom de capa'));	
						}
					}
				}else if(undefined != accio[0] && accio[0].indexOf("feature_profile") != -1) {

					$("body").trigger("showProfile", [accio[1]]);

				}else{
					//accio tanca
					InstamapsUtils.Mapa.closePopup(jQuery, map);
					$('#sidebar').attr("class","unactive");
					$('.leaflet-control-scale.leaflet-control').removeClass("popup-active");
				}
			});	
			
			$(document).on('click', ".bs-ncapa li a", function(e) {
				e.preventDefault();
				var accio;
				if($(this).attr('id').indexOf('#')!=-1){			
					accio=$(this).attr('id').split("#");				
				}
				
				objEdicio.featureID=accio[1];
				if(accio[0].indexOf("layer_edit")!=-1){
					objEdicio.edicioPopup='textCapa';
					$('#layer_accio').text(window.lang.translate('Canviar el nom de la capa'))
					$('#capa_edit').val($('#cmbCapesUsr').val());
					modeLayerTextEdit();

				}else if(accio[0].indexOf("layer_add")!=-1){
					objEdicio.edicioPopup='nouCapa';
					$('#layer_accio').text(window.lang.translate('Nom nova capa'))
					$('#capa_edit').val("").attr('placeholder',window.lang.translate('Nova capa'));
					modeLayerTextEdit();
				}else{
					
				}
			});
			
			$(document).on('focus', ".bs-ncapa li select", function(e) {
				 $(this).data('cmbCapesUsr_old',$(this).val());
			 });	 
			 
			 $(document).on('change', ".bs-ncapa li select", function(e) {
				    e.stopImmediatePropagation();
				    
					e.preventDefault();
					e.stopPropagation();		    
					var accio;
					if($(this).attr('id').indexOf('-')!=-1){			
						accio=$(this).attr('id').split("-");				
					}
					objEdicio.featureID=accio[1];
					var toBusinessId = $(this).val().split("#");
					var fromBusinessId = $(this).data('cmbCapesUsr_old').split("#");
					//Actualitzem valor antic
					$(this).data('cmbCapesUsr_old',$(this).val());
					
					objEdicio.featureID=accio[1];
					var obj = map._layers[objEdicio.featureID];
					
					var estilL=obj.properties.estil;
					if (estilL.opacity){
						if (estilL.opacity===0.25) estilL.opacity = 25;
						else if (estilL.opacity===0.5) estilL.opacity = 50;
						else if (estilL.opacity===0.75) estilL.opacity = 75;
					}
					/*NOU MODEL*/
					var features = {
						type: obj.properties.tipusFeature,
						id:3124,
						businessId: obj.properties.businessId,//Bid de la geometria q estas afegint
						properties: obj.properties.data,
						estil: estilL,
						geometry: obj.properties.feature.geometry
					};
					
					features = JSON.stringify(features);
					
					var data = {
						toBusinessId: toBusinessId[0],//bID de la visualitzacio-capa
						fromBusinessId: fromBusinessId[0],//bID de la visualitzacio-capa
						uid: Cookies.get('uid'),
						features: features
					};
					
					InstamapsUtils.Mapa.closePopup(jQuery, map);
					$('#sidebar').attr("class","unactive");
					$('.leaflet-control-scale.leaflet-control').removeClass("popup-active");

					moveGeometriaToVisualitzacio(data).then(function(resultsMove) {
						if(resultsMove.status === 'OK'){

							reloadSingleLayer(controlCapes._layers[accio[3]], resultsMove.layerFrom);
							reloadSingleLayer(controlCapes._layers[toBusinessId[1]], resultsMove.layerTo);
							
						}else{
							console.debug("moveGeometriaToVisualitzacio ERROR");
						}
					},function(results){
						console.debug("moveGeometriaToVisualitzacio ERROR");
					});					
			 });

		},

		showErrorModal: function(msg){
			//TODO refactoring - esto se deberia cambiar por emitir un evento
			$('#dialog_error_upload_txt').html("");
									
			$('#dialog_error_upload_txt').text(window.lang.translate(msg));										
							
			$('#dialog_error_upload').modal('show');
		},

		esGeometriaEditable: function(feature){
			var geomEditable = false;
			if(feature.editing){
				try{
					if (feature.properties.feature.geometry!==undefined && (feature.properties.feature.geometry.type.indexOf("Multi")>-1 
					|| feature.properties.feature.geometry.type.indexOf("multi")>-1)){
						return false;
					}
					else {
						return true;
					}	
				}catch(e){
					return true;
				}			
			}
			return geomEditable;
		},
		
		modificarDadesGeometria:function(id){
			var self=this;
			$("#"+id).hide();				
			$("#"+id.replace("_2","")).show();
			var modified = self.modified;
			var keys = Object.keys(modified);
			InstamapsUtils.Mapa.closePopup(jQuery, map);
			if(0 != keys.length)
			{
				if (self.businessidGeom==undefined) {
					self.businessidGeom = "";
					self.businessidGeom = $('#businessidGeom').val();
				}
				else if(self.businessidGeom!==$('#businessidGeom').val()){
					self.businessidGeom = $('#businessidGeom').val();
				}
				var dataUpdate ={
						uid:Cookies.get('uid'),
						businessId: self.businessidGeom,//PENDENT!!!
						newValue: JSON.stringify(self.modified)
					};
				updateGeometriaPropertiesByBusinessId(dataUpdate).then(function(results){
					if (results.status == "OK"){
						self.modified={};		
						self.clicked = {};
						var layerServidor = results.servidor;
						InstamapsUtils.Mapa.findLayerByBusinessId(layerServidor.businessId).then(function(layerAct2){							
							reloadSingleLayer(controlCapes._layers[layerAct2._leaflet_id], layerServidor);
						});
						
					}else{
						console.debug('error updateGeometriaProperties');
					}
				},function(results){
					console.debug('error updateGeometriaProperties');
				});	
			}	
		},

		getOptions: function() {
			var self = this;
			return self.options;
		},

		_createPopupFromClick: function(e, data) {
			var self = this;
			if(controlCapes){
				var visibleLayers = controlCapes.getVisibleLayers(PopupManager().getOptions().addSublayers);
				if (data.isDraw!==undefined && data.isDraw){
					$.publish('showPinPopup', data.element.properties.popupData);
				}
				else {
					self.createMergedDataPopup(data.element, data.event, visibleLayers).then(function(results){
						if((results.features!==undefined && results.features.length > 0) || results!=undefined) {
							$.publish('showPinPopup', results);
						}
					});
				}
			}else{
				var visibleLayers = InstamapsLayers().getVisibleLayers(PopupManager().getOptions().addSublayers);
				self.createMergedDataPopup(data.element, data.event, visibleLayers, false).then(function(results){
					if((results.features!==undefined && results.features.length > 0) || results!=undefined) {
						$.publish('showPinPopup', results);
					}
				});
			}
		},

		_isClickUnderPanel: function(e){
			var resp = {isUnder:false, center: null};
			if(window.outerWidth < 1240){ //pantallas pequeñas

			}else{ //pantallas grandes

				var pos = 0;
				if(e.containerPoint) {
					pos = e.containerPoint.x;
				} else if(e.originalEvent) {
					pos = e.originalEvent.clientX;
				} else if(e.latlng) {
					pos = map.project(e.latlng, map.getZoom()).x;
				}

				if(pos > (window.outerWidth*0.75)){
					//console.logconsole.log('mover el mapa');
					resp.isUnder = true;
					resp.center = e.latlng
				}else{
					//console.log('dejar igual');
				}
			}
			return resp;
		},

		_onPinClicked: function(e, data) {
			var self = this;
			if (data!==undefined && data.features!==undefined){
				var feat = data.features[0];
				if (feat!==undefined) {
					$('.sidebar-body').html(feat.htmlContent);
				}
			}
			else {
				$('.sidebar-body').html(data);
			}
			
			$('#sidebar').attr("class","active");
			$('.leaflet-control-scale.leaflet-control').addClass("popup-active");
			self.addComboAndEvents();
			
		},		

		_listenEvents: function(){
			var self = this;
			$.subscribe('createPopupOnclick',self._createPopupFromClick.bind(self));
			$.subscribe('showPinPopup', self._onPinClicked.bind(self));
		},

		disableControl: function(){
			this.disable = true;
		},

		enableControl: function(){
			this.disable = false;
		},

		addComboAndEvents: function(){
			var self=this;
			actualitzarComboCapes().then(function(){
				self._addPopupEvents();
			});
		}
	};

	PopupManager.init = function(inOptions)
	{
		var self = this;
		self = $.extend(self, self.options, inOptions);
		self.addEventsPopup();
		self._listenEvents();
	}

	PopupManager.init.prototype = PopupManager.prototype;

	global.PopupManager = PopupManager;

}(window, jQuery));
